const debounce = (func, delay) => {
  let debounceTimer;
  return function () {
    const context = this;
    const args = arguments;
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => func.apply(context, args), delay);
  };
};
const waitFor = async (selector) => {
  return new Promise((resolve, reject) => {
    const element = document.querySelector(selector);

    if (element) {
      resolve(element);
      return;
    }

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        const nodes = [...mutation.addedNodes];
        for (const node of nodes) {
          if (node.matches && node.matches(selector)) {
            observer.disconnect();
            resolve(node);
            return;
          }
        }
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  });
};
window.waitFor = waitFor;

// Ждет элемент внутри конкретного контейнера (waitFor ищет по всему документу)
const waitForIn = (root, selector, timeout = 15000) => {
  return new Promise((resolve) => {
    const element = root.querySelector(selector);

    if (element) {
      resolve(element);
      return;
    }

    const observer = new MutationObserver(() => {
      const found = root.querySelector(selector);
      if (found) {
        observer.disconnect();
        clearTimeout(timer);
        resolve(found);
      }
    });

    const timer = setTimeout(() => {
      observer.disconnect();
      resolve(null);
    }, timeout);

    observer.observe(root, { childList: true, subtree: true });
  });
};
window.waitForIn = waitForIn;

window.productsSlickSettings = {
  slidesToShow: 4,
  infinite: false,
  responsive: [
    {
      breakpoint: 1171,
      settings: {
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 890,
      settings: {
        slidesToShow: 2,
      },
    },
  ],
};
window.mmLanguage = dataLayer[0].shoptet.language;

const handleHeader = async () => {
  const navigation = document.querySelector("#navigation");
  const siteNameWrapper = document.querySelector(".site-name-wrapper");
  if (navigation && siteNameWrapper) siteNameWrapper.after(navigation);
  const menuHelper = document.querySelector(".menu-helper");
  if (menuHelper && navigation)
    navigation.parentElement.insertBefore(
      menuHelper,
      navigation.nextElementSibling,
    );
  const navigationButtons = document.querySelector(".navigation-buttons");
  const loginButton =
    document.querySelector(".top-nav-button-account") ||
    document.querySelector(".top-nav-button-login");
  if (navigationButtons && loginButton) navigationButtons.prepend(loginButton);
  const searchButton = document.querySelector(
    '.toggle-window[data-target="search"]',
  );
  if (navigationButtons && searchButton)
    navigationButtons.prepend(searchButton);
  const menuTrigger = document.querySelector(
    '.toggle-window[data-target="navigation"]',
  );
  if (menuTrigger && navigationButtons)
    navigationButtons.appendChild(menuTrigger);
  const topNavigationBar = document.querySelector(".top-navigation-bar");
  const siteHeader = document.querySelector("#header");
  const navigationIn = document.querySelector(".navigation-in");
  if (topNavigationBar) {
    if (window.innerWidth >= 768) {
      if (topNavigationBar.nextElementSibling !== siteHeader) {
        siteHeader.parentElement.insertBefore(topNavigationBar, siteHeader);
      }
    } else {
      if (topNavigationBar.parentElement !== navigationIn) {
        navigationIn.appendChild(topNavigationBar);
      }
    }
    document.addEventListener("resizeEnd", () => {
      if (window.innerWidth >= 768) {
        if (topNavigationBar.nextElementSibling !== siteHeader) {
          siteHeader.parentElement.insertBefore(topNavigationBar, siteHeader);
        }
      } else {
        if (topNavigationBar.parentElement !== navigationIn) {
          navigationIn.appendChild(topNavigationBar);
        }
      }
    });
  }

  // if (window.innerWidth >= 767) {
  const menuLvl2s = document.querySelectorAll("#navigation .menu-level-2");
  // menuLvl2s.forEach((menuLvl2) => {
  //   const helper = document.createElement("div");
  //   helper.classList.add("menu-level-2-helper");
  //   menuLvl2.parentElement.insertBefore(helper, menuLvl2);
  //   helper.appendChild(menuLvl2);
  //   const menuLvl2Images = menuLvl2.querySelectorAll("li .menu-image img");
  //   menuLvl2Images.forEach((img) => {
  //     const imgSrc = img.getAttribute("src");
  //     const imgDataSrc = img.getAttribute("data-src");
  //     if (imgSrc !== imgDataSrc && imgDataSrc) img.src = imgDataSrc;
  //   });
  // });
  // }

  const headerTop = document.querySelector("#header .header-top");
  const search = document.querySelector(".header-top .search");
  const siteMessage = document.querySelector(".site-msg.information") || 0;
  if (headerTop) {
    if (window.innerWidth <= 767) {
      header.style.setProperty(
        "--header-top-height",
        `${
          headerTop.clientHeight + (siteMessage ? siteMessage.clientHeight : 0)
        }px`,
      );
    } else {
      header.style.setProperty(
        "--header-top-height",
        `${headerTop.clientHeight}px`,
      );
    }
  }
  const menuImages = document.querySelectorAll(".menu-level-2 .menu-image img");

  menuImages.forEach((img) => {
    let url = img.getAttribute("data-src") || img.getAttribute("src");

    img.src = img.src.replace("/thumb/", "/orig/");
    if (img.dataset.src) {
      img.dataset.src = img.dataset.src.replace("/thumb/", "/orig/");
    }
  });

  // const menuImages = document.querySelectorAll("#navigation .menu-image img");
  // menuImages?.forEach((img) => {
  //   let imgSrc = img.getAttribute("src");

  //   imgSrc = imgSrc.replace("/thumb/", "/orig/");
  // });

  // const socialIcons = document.querySelector(".footer-links-icons");
  // const topNavMenu = document.querySelector(
  //   ".top-navigation-bar .top-navigation-menu"
  // );
  // if (socialIcons) {
  //   socialIcons.classList.remove("container");
  //   if (topNavMenu) {
  //     topNavMenu.parentElement.insertBefore(socialIcons, topNavMenu);
  //   } else {
  //     socialIcons.remove();
  //   }
  // }
};
handleHeader();
function truncateHTML(element, maxLength) {
  let length = 0;

  function truncate(node) {
    if (length >= maxLength) {
      node.remove();
      return;
    }

    if (node.nodeType === Node.TEXT_NODE) {
      if (length + node.textContent.length > maxLength) {
        node.textContent =
          node.textContent.slice(0, maxLength - length) + "...";
        length = maxLength;
      } else {
        length += node.textContent.length;
      }
    } else if (node.nodeType === Node.ELEMENT_NODE) {
      [...node.childNodes].forEach(truncate);
    }
  }

  const clone = element.cloneNode(true);
  truncate(clone);
  return clone;
}

function toggleMoreInfo() {
  const categoryPerex = document.querySelector(".category-perex");
  if (!categoryPerex) return;

  const fullHTML = categoryPerex.innerHTML;
  const fullText = categoryPerex.innerText;

  if (fullText.length > 200) {
    const truncatedClone = truncateHTML(categoryPerex, 200);

    const moreInfoButton = document.createElement("button");
    moreInfoButton.classList.add("btn", "btn-secondary", "more-info-button");
    moreInfoButton.textContent = "zjistit více";
    categoryPerex.insertAdjacentElement("afterend", moreInfoButton);

    categoryPerex.innerHTML = truncatedClone.innerHTML;

    let isExpanded = false;
    moreInfoButton.addEventListener("click", () => {
      if (isExpanded) {
        categoryPerex.innerHTML = truncatedClone.innerHTML;
        moreInfoButton.textContent = "zjistit více";
      } else {
        categoryPerex.innerHTML = fullHTML;
        moreInfoButton.textContent = "skrýt";
      }
      isExpanded = !isExpanded;
    });
  }
}

const handleCategory = async (reload = false) => {
  const categoryTopDuplicate = document.querySelector(".category-top-wrapper");
  const categoryTitleDuplicate = document.querySelector(
    "#content .category-title",
  );
  const categoryTop = document.querySelector("#content .category-top");
  const categoryContentWrapper = document.querySelector("#content-wrapper");
  const subcategories = document.querySelector("#content .subcategories");

  if (categoryTopDuplicate) {
    if (categoryTop) categoryTop.remove();
    if (subcategories) subcategories.remove();
    if (categoryTitleDuplicate) categoryTitleDuplicate.remove();
  } else {
    const categoryTopWrapper = document.createElement("div");
    categoryTopWrapper.classList.add("category-top-wrapper");
    categoryContentWrapper.parentElement.insertBefore(
      categoryTopWrapper,
      categoryContentWrapper,
    );
    const categoryTopContainer = document.createElement("div");
    categoryTopContainer.classList.add("category-top-content");
    categoryTopWrapper.appendChild(categoryTopContainer);
    const categoryTitle = document.querySelector(".category-title");
    const categoryPerex = document.querySelector(
      ".category-perex:not(.empty-content)",
    );
    if (categoryTitle) categoryTopContainer.appendChild(categoryTitle);

    if (categoryPerex) {
      const allParagraphs = categoryPerex.querySelectorAll("p");
      allParagraphs.forEach((p) => {
        if (p.innerText.trim() === "#SHOW_MORE#") {
          p.innerHTML = "";
          const showMoreButton = document.createElement("button");
          showMoreButton.classList.add("show-more", "btn", "btn-secondary");
          showMoreButton.innerHTML = "Více informací";
          showMoreButton.setAttribute(
            "data-alternative-text",
            "Méně informací",
          );
          p.appendChild(showMoreButton);
          categoryPerex.classList.add("show-more");
          showMoreButton.addEventListener("click", () => {
            categoryPerex.classList.toggle("show-more");
            const help = showMoreButton.getAttribute("data-alternative-text");
            showMoreButton.setAttribute(
              "data-alternative-text",
              showMoreButton.innerText,
            );
            showMoreButton.innerText = help;
          });
        }
      });
      categoryTopContainer.appendChild(categoryPerex);
    }

    const breadcrumbsWrapper = document.querySelector(".breadcrumbs-wrapper");
    if (breadcrumbsWrapper) categoryTopWrapper.prepend(breadcrumbsWrapper);

    categoryTopContainer.appendChild(categoryTop);
    if (subcategories) {
      categoryTopWrapper.appendChild(subcategories);
      subcategories.classList.add("container");
    }

    const categoryImage =
      categoryTop.querySelector("p > img") ||
      categoryTop.querySelector("p > span > img");
    const imageWrapper = document.createElement("div");
    imageWrapper.classList.add("category-image");
    if (categoryImage) {
      const toRemove = categoryImage.closest("p");
      imageWrapper.appendChild(categoryImage);
      toRemove.remove();
    } else {
      const categoryVideo = document.querySelector("p > video");
      if (categoryVideo) {
        const toRemove = categoryVideo.closest("p");
        imageWrapper.appendChild(categoryVideo);
        categoryVideo.removeAttribute("controls");
        categoryVideo.setAttribute("preload", "auto");
        // categoryVideo.width = '454'
        // categoryVideo.height = '278'
        toRemove.remove();
        const playVideoButton = document.createElement("button");
        playVideoButton.classList.add("play-video");
        playVideoButton.innerHTML = `<img src="https://cdn.myshoptet.com/usr/343520.myshoptet.com/user/documents/projects/worksafety/assets/img/play-video.png" alt="Přehrát video" width="167" height="124" />`;
        imageWrapper.appendChild(playVideoButton);
        playVideoButton.addEventListener("click", () => {
          categoryVideo.play();
          playVideoButton.remove();
          categoryVideo.setAttribute("controls", "");
        });
      }
    }
    categoryTop.prepend(imageWrapper);
    const categoryTopBG = document.querySelector("#data-background");
    if (categoryTopBG) {
      categoryTopContainer.style.backgroundColor =
        categoryTopBG.getAttribute("data-background");
      categoryTopBG.remove();
    }
  }

  const categoryTopWrapper = document.querySelector(".category-top-wrapper");
  if (!reload) {
    const setBackground = (desktopImg, mobileImg) => {
      let desktop = desktopImg;
      let mobile = mobileImg;
      if (!desktop) desktop = mobileImg;
      if (!mobile) mobile = desktopImg;
      if (categoryTopWrapper) {
        categoryTopWrapper.classList.add("has-background");
        // categoryTopWrapper.style.backgroundImage = window.innerWidth > 767 ? `url(${desktopImg})` : `url(${mobileImg})`
        categoryTopWrapper.setAttribute("data-desktop", desktop);
        categoryTopWrapper.setAttribute("data-mobile", mobile);
      }
    };
    const categoryBG = document.querySelectorAll(
      ".category__secondDescription > p img",
    );
    if (categoryBG.length) {
      let desktopImg;
      let mobileImg;
      let otherImages = [];
      let otherImagesDesktop = [];
      let otherImagesMobile = [];
      let imagesLoading = [];
      categoryBG.forEach((img) => {
        imagesLoading.push(
          new Promise((resolve) => {
            if (img.complete) {
              if (img.naturalWidth > 1900) {
                desktopImg = img;
              } else if (img.naturalWidth <= 1900 && img.naturalWidth >= 767) {
                mobileImg = img;
              } else if (img.naturalWidth < 767 && img.naturalWidth > 500) {
                otherImagesDesktop.push(img);
              } else if (img.naturalWidth <= 500) {
                otherImagesMobile.push(img);
              } else {
                otherImages.push(img);
              }
              img.closest("p").remove();
              resolve();
            } else {
              img.addEventListener("load", () => {
                if (img.naturalWidth > 1900) {
                  desktopImg = img;
                } else if (
                  img.naturalWidth <= 1900 &&
                  img.naturalWidth >= 767
                ) {
                  mobileImg = img;
                } else if (img.naturalWidth < 767 && img.naturalWidth > 500) {
                  otherImagesDesktop.push(img);
                } else if (img.naturalWidth <= 500) {
                  otherImagesMobile.push(img);
                } else {
                  otherImages.push(img);
                }
                img.closest("p").remove();
                resolve();
              });
            }
          }),
        );
      });
      Promise.all(imagesLoading)
        .then(() => {
          // setBackground(desktopImg, mobileImg)
          if (desktopImg) {
            desktopImg.classList.add("desktop", "background-image");
            categoryTopWrapper.appendChild(desktopImg);
            categoryTopWrapper.classList.add("has-background");
          }
          if (mobileImg) {
            mobileImg.classList.add("mobile", "background-image");
            categoryTopWrapper.appendChild(mobileImg);
            categoryTopWrapper.classList.add("has-background");
          }
          if (otherImagesDesktop.length) {
            const categoryTopContainer = document.querySelector(
              ".category-top-wrapper > .category-top-content",
            );
            if (categoryTopContainer) {
              const categoryImages = document.createElement("div");
              categoryImages.classList.add("category-images", "desktop");
              categoryTopContainer.appendChild(categoryImages);
              otherImagesDesktop.forEach((img) => {
                const otherImageLink = img.closest("a");
                if (otherImageLink) {
                  categoryImages.appendChild(otherImageLink);
                } else {
                  categoryImages.appendChild(img);
                }
              });
              $(categoryImages).slick({
                slidesToShow: 1,
                arrows: true,
                dots: true,
                autoplay: true,
                autoplaySpeed: 5000,
              });
            }
          }
          if (otherImagesMobile.length) {
            const categoryTopContainer = document.querySelector(
              ".category-top-wrapper > .category-top-content",
            );
          }
        })
        .catch((e) => {
          console.log(e);
        });
    } else {
      categoryTopWrapper.classList.remove("has-background");
    }
  } else {
    const categoryBG = document.querySelectorAll(
      ".category__secondDescription > p img",
    );
    for (let img of categoryBG) {
      img.closest("p").remove();
    }
  }

  if (subcategories) {
    const subcategoriesImages = subcategories.querySelectorAll(".image img");
    subcategoriesImages.forEach((image) => {
      image.src = image.src.replace("/thumb/", "/orig/");
      if (image.dataset.src) {
        image.dataset.src = image.dataset.src.replace("/thumb/", "/orig/");
      }
    });
    // const showCategoriesBtn = document.createElement("button");
    // showCategoriesBtn.classList.add("show-categories", "btn");
    // showCategoriesBtn.innerHTML = "Subkategorie";
    // subcategories.prepend(showCategoriesBtn);
    // showCategoriesBtn.addEventListener("click", () => {
    //   subcategories.classList.toggle("show");
    // });
  }
  // const secondDescription = document.querySelector('.category__secondDescription')
  // if (secondDescription) {
  // 	secondDescription.id = 'dlouhy-popis'
  // 	const categoryContent = document.querySelector('#content')
  // 	categoryContent.parentElement.insertBefore(secondDescription, categoryContent.nextElementSibling)
  // }
  const categoryBanners = document.querySelectorAll(".banner-category");
  const firstProductBlock = document.querySelector("#products");
  const secondProductBlock = document.querySelector(
    ".products-block:not(#products)",
  );
  if (secondProductBlock) {
    const secondBlockProducts = secondProductBlock.querySelectorAll(".product");
    secondBlockProducts.forEach((product) => {
      if (firstProductBlock) firstProductBlock.appendChild(product);
    });
    secondProductBlock.remove();
  }
  categoryBanners.forEach((categoryBanner, index) => {
    if (categoryBanner && firstProductBlock) {
      categoryBanner.classList.add("product");
      let whereToAppend = null;
      switch (index) {
        case 0:
          whereToAppend = firstProductBlock.querySelector(
            ".product:nth-child(3)",
          );
          break;
        case 1:
          whereToAppend = firstProductBlock.querySelector(
            ".product:nth-child(14)",
          );
          break;
      }
      if (whereToAppend) {
        whereToAppend.after(categoryBanner);
      } else {
        firstProductBlock.appendChild(categoryBanner);
      }
    }
  });
  const filtersWrapper = document.querySelector("#filters-wrapper");
  const categoryHeader = document.querySelector("#category-header");
  if (categoryHeader) {
    if (filtersWrapper) filtersWrapper.after(categoryHeader);

    // const filters = document.querySelector('#filters')
  }
  // const productsAnchor = document.querySelector('.category-top a[href="#products"]')
  // if (productsAnchor) {
  // 	productsAnchor.addEventListener('click', (e) => {
  // 		e.preventDefault()
  // 		e.stopPropagation()
  // 		const products = document.querySelector('#products')
  // 		products.scrollIntoView({ behavior: 'smooth' })
  // 	})
  // }
  // const dlouhyPopisAnchor = document.querySelector('.category-top a[href="#dlouhy-popis"]')
  // if (dlouhyPopisAnchor) {
  // 	dlouhyPopisAnchor.addEventListener('click', (e) => {
  // 		e.preventDefault()
  // 		e.stopPropagation()
  // 		const dlouhyPopis = document.querySelector('.category__secondDescription')
  // 		dlouhyPopis.scrollIntoView({ behavior: 'smooth' })
  // 	})
  // }
  // const unveilFilters = document.querySelector('.filters-unveil-button-wrapper')
  // if (unveilFilters && window.innerWidth <= 767) categoryTop.appendChild(unveilFilters)
  // const categoryBackTop = document.querySelector('.pagination-top')
  // if (categoryBackTop) {
  // 	const categorySecondDescription = document.querySelector('.category__secondDescription')
  // 	if (categorySecondDescription) {
  // 		const buttonsWrapper = document.createElement('div')
  // 		buttonsWrapper.classList.add('buttons-wrapper', 'buttons-center')
  // 		categorySecondDescription.appendChild(buttonsWrapper)
  // 		buttonsWrapper.appendChild(categoryBackTop)
  // 	}
  // }
  // const topProducts = document.querySelector('#productsTop')
  // if (topProducts) {
  // 	const topProductsHeading = topProducts.previousElementSibling
  // 	const categoryContentMain = document.querySelector('#content')
  // 	categoryContentMain.prepend(topProducts)
  // 	categoryContentMain.prepend(topProductsHeading)
  // }
  // if (window.innerWidth <= 767) {
  //   const subcatsFilterWrapperHelp = document.querySelector(
  //     ".subcategories-filter-wrapper"
  //   );
  //   if (!subcatsFilterWrapperHelp) {
  //     const subcatsFilterWrapper = document.createElement("div");
  //     subcatsFilterWrapper.classList.add("subcategories-filter-wrapper");
  //     const filters = document.querySelector("#filters-wrapper");
  //     filters.parentElement.insertBefore(subcatsFilterWrapper, filters);
  //     const subcategories = document.querySelector(".subcategories");
  //     const categoryOrdering = document.querySelector("#category-header");
  //     const orderTriggerHelp = document.querySelector(".order-trigger");
  //     // if (subcategories) subcatsFilterWrapper.appendChild(subcategories)
  //     if (filters) subcatsFilterWrapper.appendChild(filters);
  //     if (categoryOrdering && !orderTriggerHelp) {
  //       const selectedOrder = categoryOrdering.querySelector(
  //         'input[type="radio"]:checked'
  //       );
  //       const orderTrigger = document.createElement("button");
  //       orderTrigger.classList.add("order-trigger", "btn");
  //       orderTrigger.innerHTML =
  //         "Řazení" +
  //         (selectedOrder
  //           ? `<span>(${selectedOrder.nextElementSibling.innerText})</span>`
  //           : "");
  //       subcatsFilterWrapper.appendChild(orderTrigger);
  //       orderTrigger.addEventListener("click", () => {
  //         categoryOrdering.classList.toggle("show");
  //       });
  //     } else if (orderTriggerHelp)
  //       subcatsFilterWrapper.appendChild(orderTriggerHelp);
  //     const filtersUnveilButton = document.querySelector(
  //       '.unveil-button[data-unveil="filters"]'
  //     );
  //     if (filtersUnveilButton) filtersUnveilButton.innerHTML = "Filtry";
  //   }
  // }
  // toggleMoreInfo();
};
if (dataLayer[0].shoptet.pageType === "category") {
  handleCategory();
  document.addEventListener("ShoptetDOMContentLoaded", () =>
    handleCategory(true),
  );
}

const handleProductDetail = async () => {
  const pInnerHeader = document.querySelector(".p-detail-inner-header");
  const pDetailInfo = document.querySelector(".p-detail-info");
  const pInfoWrapper = document.querySelector(".p-info-wrapper");
  const pImage = document.querySelector(".p-image-wrapper .p-image");
  const flagsDefault = document.querySelector(".product-top .flags-default");
  const pDetailInner = document.querySelector(".p-detail-inner");
  // const flagsExtra = document.querySelector('.p-detail .flags-extra')
  // if (flagsDefault && flagsExtra) {
  // 	flagsDefault.appendChild(flagsExtra)
  // 	flagsDefault.classList.add('contains-extra')
  // }

  const rateFormTrigger = document.querySelector(
    "#ratingTab .rate-form-trigger",
  );
  const rateForm = document.querySelector("#ratingTab #rate-form");
  const votesWrap = document.querySelector("#ratingTab .votes-wrap");
  const ratingWrapper = document.querySelector("#ratingTab #ratingWrapper");

  if (rateFormTrigger && rateForm) {
    if (votesWrap) {
      votesWrap.insertAdjacentElement("afterend", rateFormTrigger);
      rateFormTrigger.insertAdjacentElement("afterend", rateForm);
    } else if (ratingWrapper) {
      ratingWrapper.insertAdjacentElement("afterend", rateFormTrigger);
      rateFormTrigger.insertAdjacentElement("afterend", rateForm);
    }
  }
  if (pInnerHeader && pDetailInfo) pInnerHeader.appendChild(pDetailInfo);
  if (pInfoWrapper && pInnerHeader) pInfoWrapper.prepend(pInnerHeader);
  const productTitle = pInnerHeader.querySelector("h1");
  if (window.innerWidth <= 903) {
    pDetailInner.prepend(pInnerHeader);
  }
  document.addEventListener("resizeEnd", () => {
    if (window.innerWidth <= 903) {
      pDetailInner.prepend(pInnerHeader);
    } else {
      // pInnerHeader?.prepend(pInnerHeader);
    }
  });
  const priceMeasure = pInfoWrapper.querySelector(".price-measure");

  if (priceMeasure) {
    priceMeasure.querySelectorAll("span").forEach((span) => {
      span.textContent = span.textContent.replace(/m2/g, "m²");
    });
  }

  if (flagsDefault) {
    if (window.innerWidth > 767) {
      if (pImage) pImage.appendChild(flagsDefault);
    } else {
      if (pInnerHeader) pInnerHeader.appendChild(flagsDefault);
    }
  }
  const elements = document.querySelectorAll(
    "a[href], img[src], img[data-src]",
  );

  elements.forEach((el) => {
    // if (el.hasAttribute("href")) {
    //   el.href = el.href
    //     .replace("/big/", "/orig/")
    //     .replace("/related/", "/orig/");
    // }
    if (el.hasAttribute("src")) {
      el.src = el.src.replace("/big/", "/orig/").replace("/related/", "/orig/");
    }
    if (el.hasAttribute("data-src")) {
      el.setAttribute(
        "data-src",
        el
          .getAttribute("data-src")
          .replace("/big/", "/orig/")
          .replace("/related/", "/orig/"),
      );
    }
    if (el.hasAttribute("data-href")) {
      el.setAttribute(
        "data-href",
        el
          .getAttribute("data-href")
          .replace("/big/", "/orig/")
          .replace("/related/", "/orig/"),
      );
    }
  });

  const pThumbnails = document.querySelector(".p-thumbnails");
  if (pThumbnails) {
    const thumbnailsTrack = pThumbnails.querySelector(
      ".p-thumbnails-inner > div",
    );
    setTimeout(() => {
      if (
        thumbnailsTrack &&
        pThumbnails.clientWidth < thumbnailsTrack.clientWidth
      ) {
        pThumbnails.classList.add("overflow-next");
      }
    }, 500);
  }

  const customAddToCart = document.createElement("div");
  customAddToCart.classList.add("add-to-cart-wrapper");
  const productPrices = document.querySelector(".p-final-price-wrapper");
  if (productPrices) customAddToCart.appendChild(productPrices);

  const productQuantity = document.querySelector(".add-to-cart .quantity");
  if (productQuantity) customAddToCart.appendChild(productQuantity);
  const addToCart = document.querySelector(".add-to-cart");
  if (addToCart) {
    const btn = addToCart.querySelector(".add-to-cart-button");
    if (btn) btn.innerText = "Koupit";

    customAddToCart.appendChild(addToCart);

    const vzorkyBtn = addToCart.querySelector(".vzorky-button");
    if (!vzorkyBtn) {
      const skuMeta = document.querySelector('meta[itemprop="sku"]');
      const productCode = skuMeta?.content?.trim();
      if (productCode) {
        (async () => {
          try {
            const response = await fetch(
              `https://vpodlahy.mirandamedia.io/api/eshop/product-with-sample/code/${productCode}`,
            );
            if (!response.ok) return;

            const data = await response.json();
            if (!data.hasSample) return;

            const sampleVariant = data.sample.variants?.[0];
            if (!sampleVariant) return;

            const newVzorkyBtn = document.createElement("button");
            newVzorkyBtn.type = "button";
            newVzorkyBtn.classList.add("vzorky-button", "btn", "btn-default");
            newVzorkyBtn.innerText = "Vzorek";

            newVzorkyBtn.addEventListener("click", () => {
              try {
                const result = shoptet.cartShared.addToCart({
                  productCode: sampleVariant.code,
                  amount: 1,
                });
              } catch (err) {
                console.error("Chyba v addToCart:", err);
              }

              newVzorkyBtn.innerText = "Přidáno";
              newVzorkyBtn.disabled = true;
            });

            addToCart.appendChild(newVzorkyBtn);
          } catch (err) {
            console.error("Chyba při načítání vzorku:", err);
          }
        })();
      }
    }
  }

  pInfoWrapper.appendChild(customAddToCart);

  let productWarranty = document.querySelectorAll(
    ".extended-description .detail-parameters .row-header-label",
  );
  if (productWarranty.length) {
    for (const item of productWarranty) {
      if (item.innerText.includes("Záruka")) {
        productWarranty = item.closest("tr");
        break;
      } else {
        productWarranty = null;
      }
    }
    if (productWarranty) {
      const productBenefits = document.createElement("div");
      productBenefits.classList.add("product-benefits");
      productBenefits.appendChild(productWarranty);
      pInfoWrapper.appendChild(productBenefits);
      const productReturn = document.createElement("tr");
      productReturn.innerHTML = `
				<th>Výměna</th><td>do 30 dní.</td>
			`;
      productBenefits.appendChild(productReturn);
    }
  }

  if (!addToCart) {
    document.body.classList.add("discontinued-product");
    customAddToCart.classList.add("discontinued");
    customAddToCart.innerHTML = `
			<strong class="text-center">Prodej tohoto produktu skončil</strong>
		`;
    const productCode = document.querySelector(
      ".p-detail-inner-header .p-code",
    );
    if (productCode) pInfoWrapper.appendChild(productCode);
  }

  const variantsWithImage = document.querySelectorAll(
    ".advanced-parameter.has-image",
  );
  variantsWithImage.forEach((variant) => {
    const variantTooltip = variant.querySelector(".show-tooltip");
    if (variantTooltip) {
      const text =
        variantTooltip.getAttribute("data-original-title") ||
        variantTooltip.getAttribute("title");
      const textEl = document.createElement("span");
      textEl.classList.add("variant-tooltip");
      textEl.innerHTML = text;
      variant.appendChild(textEl);
    }
  });

  window.waitFor("#dkLabFavouriteDiv").then(() => {
    const dkLabFavoutideDiv = document.querySelector("#dkLabFavouriteDiv");
    const linkIcons = document.querySelector(".link-icons");
    if (dkLabFavoutideDiv && linkIcons) {
      linkIcons.prepend(dkLabFavoutideDiv);
    }
  });

  const readDescription = document.querySelector(
    ".product-top a.chevron-down-after",
  );
  if (readDescription) {
    readDescription.removeAttribute("data-toggle");
    readDescription.removeAttribute("data-force-scroll");
  }

  const socialButtons = document.querySelector(".social-buttons");
  const socialButtonsClose = document.querySelector(
    ".social-buttons .close-wrapper",
  );
  if (socialButtons) {
    const copyLinkBtn = document.createElement("div");
    copyLinkBtn.classList.add("copy-link", "btn");
    copyLinkBtn.innerHTML = "Kopírovat odkaz";
    copyLinkBtn.addEventListener("click", () => {
      const linkToCopy = window.location.href;
      navigator.clipboard.writeText(linkToCopy);
      copyLinkBtn.innerHTML = "Odkaz zkopírován";
    });
    if (socialButtonsClose) socialButtonsClose.before(copyLinkBtn);
    else socialButtons.appendChild(copyLinkBtn);
  }
};
if (dataLayer[0].shoptet.pageType === "productDetail") handleProductDetail();

// const handlePage = () => {
// 	const pageHeader = document.querySelector('.page-header')
// 	if (pageHeader) {
// 		document.body.classList.add('has-page-header')
// 		const contentWrapper = document.querySelector('#content-wrapper')
// 		contentWrapper.parentElement.insertBefore(pageHeader, contentWrapper)
// 		const pageHeading = document.querySelector('article > header > h1') || document.querySelector('#content > div > h1')
// 		const pageHeadingPlaceholder = pageHeader.querySelector('.h1-placeholder')
// 		if (pageHeading && pageHeadingPlaceholder) {
// 			pageHeadingPlaceholder.innerHTML = ''
// 			pageHeadingPlaceholder.appendChild(pageHeading)
// 			if (document.body.classList.contains('type-posts-listing')) pageHeading.classList.add('homepage-group-title', 'text-center')
// 		}
// 	}
// }
// if (document.body.classList.contains('type-page') || document.body.classList.contains('type-posts-listing')) {
// 	handlePage()
// 	document.addEventListener('ShoptetDOMPageContentLoaded', handlePage)
// }

const handlePost = async () => {
  const postHeaderWrapper = document.createElement("div");
  postHeaderWrapper.classList.add("post-header-wrapper", "container");
  const postHeader = document.createElement("div");
  postHeader.classList.add("columns", "col-2", "align-center");
  postHeaderWrapper.appendChild(postHeader);
  const postHeaderTexts = document.createElement("div");
  postHeaderTexts.classList.add("post-header-texts", "column");
  const postHeaderImage = document.createElement("div");
  postHeaderImage.classList.add("post-header-image", "column");
  postHeader.appendChild(postHeaderTexts);
  postHeader.appendChild(postHeaderImage);
  const postDate = document.querySelector(
    '.news-item-detail meta[itemprop="datePublished"]',
  );
  if (postDate) {
    const postDateEl = document.createElement("div");
    postDateEl.classList.add("post-date");
    postDateEl.innerHTML = new Date(
      postDate.getAttribute("content"),
    ).toLocaleString("cs-CZ", {
      year: "numeric",
      month: "numeric",
      day: "numeric",
    });
    postHeaderTexts.appendChild(postDateEl);
  }
  const postTitle = document.querySelector(
    '.news-item-detail h1[itemprop="headline"]',
  );
  if (postTitle) postHeaderTexts.appendChild(postTitle);
  const postDescriptionContent = document.querySelector(
    ".news-item-detail .text > p:first-of-type ",
  );
  if (postDescriptionContent && window.innerWidth > 767) {
    postDescriptionContent.classList.add("post-description");
    postHeaderTexts.appendChild(postDescriptionContent);
  }
  const contentWrapper = document.querySelector("#content-wrapper");
  contentWrapper.parentElement.insertBefore(postHeaderWrapper, contentWrapper);

  const postImageURL = document.querySelector(
    '.news-item-detail span[itemprop="image"] meta[itemprop="url"]',
  );
  const postImageWidth = document.querySelector(
    '.news-item-detail span[itemprop="image"] meta[itemprop="width"]',
  );
  const postImageHeight = document.querySelector(
    '.news-item-detail span[itemprop="image"] meta[itemprop="height"]',
  );
  if (postImageURL) {
    const postImage = document.createElement("img");
    postImage.src = postImageURL.getAttribute("content");
    postImage.width = postImageWidth.getAttribute("content");
    postImage.height = postImageHeight.getAttribute("content");
    postHeaderImage.appendChild(postImage);
  }
  // else {
  // 	const urlArray = []
  // 	urlArray.push(window.location.pathname.replaceAll('/blog/', '').replaceAll('/archiv/', '').replaceAll('/', ''))
  // 	const imageData = await fetchBlogImages(urlArray)
  // 	if (imageData) {
  // 		imageData.forEach((img) => {
  // 			if (window.location.pathname.includes(img.url)) {
  // 				const postImage = document.createElement('img')
  // 				postImage.src = img.image
  // 				postHeaderImage.appendChild(postImage)
  // 			}
  // 		})
  // 	}
  // }
};
if (document.body.classList.contains("type-post")) handlePost();

function getScrollbarWidth() {
  // Vytvoření div elementu
  const div = document.createElement("div");

  // Nastavení stylu divu
  div.style.overflowY = "scroll";
  div.style.width = "50px";
  div.style.height = "50px";
  div.style.visibility = "hidden";

  // Přidání divu do těla dokumentu
  document.body.appendChild(div);

  // Výpočet šířky scrollbaru
  const scrollbarWidth = div.offsetWidth - div.clientWidth;

  // Odebrání divu z těla dokumentu
  document.body.removeChild(div);

  // Vrácení šířky scrollbaru
  return scrollbarWidth;
}

document.documentElement.style.setProperty(
  "--scrollbar-width",
  `${getScrollbarWidth()}px`,
);

const handleLastVisited = () => {
  // NAPOSLEDY PROHLIZENE
  const contentObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.classList && node.querySelector(".dkLabVisitedProductsBox")) {
          const whereToAppend = document.querySelector(
            ".homepage-box.welcome-wrapper",
          );
          if (whereToAppend) {
            whereToAppend.parentElement.insertBefore(node, whereToAppend);
          }
          contentObserver.disconnect();
        }
      });
    });
  });
  const indexContent = document.querySelector(".overall-wrapper");
  if (indexContent) contentObserver.observe(indexContent, { childList: true });
};
const handleFooterBanners = () => {
  const footerBanners = document.querySelector(".footer-banners");
  const carouselBanner = document.querySelector("#carousel");
  if (footerBanners && carouselBanner)
    carouselBanner.parentElement.insertBefore(
      footerBanners,
      carouselBanner.nextElementSibling,
    );
};
if (dataLayer[0].shoptet.pageType === "homepage") {
  handleFooterBanners();
  handleLastVisited();
}

const createBlogRedirectLink = () => {
  const subcategories = document.querySelector(".subcategories");

  if (!subcategories) {
    console.warn(
      "⏳ Subcategories not found — skipping 'Vše' button creation.",
    );
    return;
  }

  const newItem = document.createElement("li");
  newItem.innerHTML = `
    <a href="/blog" class="all-posts-btn btn">
      <span class="text">Vše</span>
    </a>
  `;

  subcategories.prepend(newItem);
  return newItem;
};

const initBlogCategories = () => {
  if (!document.body.classList.contains("type-posts-listing")) return;

  const subcategories = document.querySelector(".subcategories");

  if (subcategories) {
    createBlogRedirectLink();
  } else {
    const observer = new MutationObserver(() => {
      const updatedSubcategories = document.querySelector(".subcategories");
      if (updatedSubcategories) {
        createBlogRedirectLink();
        observer.disconnect();
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }
};

document.addEventListener("DOMContentLoaded", initBlogCategories);

const handleManufacturerPage = () => {
  const manufacturerTop = document.querySelector(".manufacturer-top");
  if (manufacturerTop) {
    document.body.classList.add("has-background");
    if (manufacturerTop.classList.contains("dark"))
      document.body.classList.add("dark");
    const manufacturerContentWrapper =
      document.querySelector("#content-wrapper");
    manufacturerContentWrapper.parentElement.insertBefore(
      manufacturerTop,
      manufacturerContentWrapper,
    );
  }
  const titlePlaceholder = document.querySelector(".title-placeholder");
  if (titlePlaceholder) {
    const title = document.querySelector(".category-title");
    titlePlaceholder.innerHTML = "";
    if (title) titlePlaceholder.appendChild(title);
  }

  const showMoreButton = document.querySelector("#show-more-button");
  if (showMoreButton) {
    showMoreButton.addEventListener("click", () => {
      manufacturerTop.classList.toggle("show-more");
      if (showMoreButton.hasAttribute("data-text")) {
        const help = showMoreButton.getAttribute("data-text");
        showMoreButton.setAttribute("data-text", showMoreButton.innerText);
        showMoreButton.innerText = help;
      }
    });
  }
  const categoryLinks = document.querySelectorAll("#categories a");
  const manufacturerSlug = window.location.pathname.replace("/znacka/", "");
  categoryLinks.forEach((link) => {
    link.href = link.href.replace(/\/$/, ":" + manufacturerSlug);
  });
  if (window.innerWidth <= 767) {
    const subcatsFilterWrapper = document.createElement("div");
    subcatsFilterWrapper.classList.add("subcategories-filter-wrapper");
    const filters = document.querySelector("#filters-wrapper");
    filters.parentElement.insertBefore(subcatsFilterWrapper, filters);
    const subcategories = document.querySelector(".subcategories");
    const categoryOrdering = document.querySelector("#category-header");
    if (subcategories) subcatsFilterWrapper.appendChild(subcategories);
    if (filters) subcatsFilterWrapper.appendChild(filters);
    if (categoryOrdering) {
      const orderTrigger = document.createElement("button");
      orderTrigger.classList.add("order-trigger", "btn");
      orderTrigger.innerHTML = "Řazení";
      subcatsFilterWrapper.appendChild(orderTrigger);
      subcatsFilterWrapper.addEventListener("click", () => {
        categoryOrdering.classList.toggle("show");
      });
      subcatsFilterWrapper.appendChild(categoryOrdering);
    }
  }
};
if (document.body.classList.contains("type-manufacturer-detail"))
  handleManufacturerPage();

if (document.body.classList.contains("type-glossary")) {
  const glossaryHeader = document.createElement("div");
  glossaryHeader.classList.add("glossary-header");
  document.body.classList.add("has-background");
  const glossaryHeaderContainer = document.createElement("div");
  glossaryHeaderContainer.classList.add("container");
  glossaryHeader.appendChild(glossaryHeaderContainer);
  const glossaryTitle = document.querySelector(".content-inner h1");
  if (glossaryTitle) glossaryHeaderContainer.appendChild(glossaryTitle);
  const contentWrapper = document.querySelector("#content-wrapper");
  contentWrapper.parentElement.insertBefore(glossaryHeader, contentWrapper);
}

const handle404 = () => {
  const nextToCarouselCookie = window.sessionStorage.getItem(
    "nextToCarouselCookie",
  );
  if (!nextToCarouselCookie) {
    (async () => {
      try {
        const response = await fetch("/");
        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        const nextToCarouselWrapper = doc.querySelector(
          ".next-to-carousel-banners",
        );
        if (nextToCarouselWrapper) {
          const pageContent = document.querySelector(
            '#content div[itemprop="about"]',
          );
          if (pageContent) pageContent.appendChild(nextToCarouselWrapper);
          window.sessionStorage.setItem(
            "nextToCarouselCookie",
            nextToCarouselWrapper.innerHTML,
          );
        }
      } catch (e) {
        console.error(e);
      }
    })();
  } else {
    const nextToCarouselWrapper = document.createElement("div");
    nextToCarouselWrapper.classList.add("next-to-carousel-banners");
    nextToCarouselWrapper.innerHTML = nextToCarouselCookie;
    const pageContent = document.querySelector(
      '#content div[itemprop="about"]',
    );
    if (pageContent) pageContent.appendChild(nextToCarouselWrapper);
  }
};
if (document.body.classList.contains("id-404")) handle404();

const filtersWrapper = document.querySelector("#filters-wrapper");
const categoryHeader = document.querySelector("#category-header");
if (categoryHeader) {
  const catHeaderDiv = categoryHeader.querySelector("form + div");
  if (filtersWrapper) filtersWrapper.after(categoryHeader);
}
const pageType = dataLayer?.[0]?.shoptet?.pageType;

const SAMPLE_API = "https://vpodlahy.mirandamedia.io/api/eshop/sample-discount";

let _lastAppliedCoupon = sessionStorage.getItem("vzorkyCoupon") || null;
let _lastDiscountAmount = parseFloat(
  (parseFloat(sessionStorage.getItem("vzorkyDiscountAmount")) || 0).toFixed(5),
);
let _pendingCoupon = sessionStorage.getItem("vzorkyPendingCoupon") || null;
let _vzorkyDebounceTimer = null;
let _vzorkyInProgress = false;
let _lastCartHash = null;

function getCartItemsHash() {
  const cartItems = dataLayer?.[0]?.shoptet?.cart || [];
  return JSON.stringify(cartItems.map((i) => `${i.code}:${i.quantity}`).sort());
}

if (pageType === "cart") {
  initLisatyCart();
  attachQuantitySync();
  let initLisatyCartTimer = null;
  _lastCartHash = getCartItemsHash();

  // Pokud je kupón čekající na aplikaci (po odebrání starého) — aplikujeme hned
  if (_pendingCoupon) {
    const [pendingCode, pendingAmount] = _pendingCoupon.split("|");
    _pendingCoupon = null;
    sessionStorage.removeItem("vzorkyPendingCoupon");
    setTimeout(() => applyCoupon(pendingCode, parseFloat(pendingAmount)), 500);
  } else {
    applyVzorkyDiscount();
  }

  document.addEventListener("ShoptetDOMCartContentLoaded", () => {
    clearTimeout(initLisatyCartTimer);
    initLisatyCartTimer = setTimeout(() => {
      initLisatyCart();
      attachQuantitySync();
      cleanupLisatyLinks();
    }, 300);

    // Po AJAX odebrání kupónu — aplikujeme čekající kupón
    if (_pendingCoupon) {
      const [pendingCode, pendingAmount] = _pendingCoupon.split("|");
      _pendingCoupon = null;
      sessionStorage.removeItem("vzorkyPendingCoupon");
      setTimeout(
        () => applyCoupon(pendingCode, parseFloat(pendingAmount)),
        300,
      );
      return;
    }

    const currentHash = getCartItemsHash();
    if (currentHash !== _lastCartHash) {
      _lastCartHash = currentHash;
      clearTimeout(_vzorkyDebounceTimer);
      _vzorkyDebounceTimer = setTimeout(() => {
        applyVzorkyDiscount();
      }, 600);
    }
  });

  // document.addEventListener("ShoptetDOMCartContentLoaded", () => {
  //   initLisatyCart();
  //   attachQuantitySync();
  //   cleanupLisatyLinks();
  // });
  document.addEventListener("ShoptetDOMAdvancedOrderLoaded", () => {
    watchAddedToCartPopup();
  });
}

async function initLisatyCart() {
  const cartItems = dataLayer?.[0]?.shoptet?.cart || [];
  if (!cartItems.length) return;

  const guids = cartItems.map((i) => i.guid).join(",");

  try {
    const response = await fetch(
      `https://vpodlahy.mirandamedia.io/api/eshop/product-with-baseboard/guids/${guids}`,
    );

    if (!response.ok) {
      console.error("Chyba při načítání lišt:", response.status);
      return;
    }

    const listyData = await response.json();
    console.log("API lišt response:", listyData);

    const baseboardsMap = {};
    listyData.forEach((i) => {
      baseboardsMap[i.guid] = {
        available: i.baseboardAvailable,
        baseboards: i.baseboards,
      };
    });

    renderLisatyBlocks(cartItems, baseboardsMap);
    updateLisatyCartUI();
  } catch (err) {
    console.error("Chyba API:", err);
  }
}

function renderLisatyBlocks(cartItems, baseboardsMap) {
  cartItems.forEach((item) => {
    const guid = item.guid;

    const row = document.querySelector(`tr[data-micro-identifier="${guid}"]`);
    if (!row) return;

    const parentItemId = getItemId(row);
    if (!parentItemId) return;

    if (parentHasLisata(parentItemId)) return;
    if (row.classList.contains("has-lisaty-box")) return;

    const listy = baseboardsMap[guid];
    if (!listy?.available) return;

    const box = document.createElement("div");
    box.className = "vp-lisaty-box";

    const toggle = document.createElement("button");
    toggle.textContent = "VYBERTE ZVÝHODNĚNOU LIŠTU K PODLAZE";
    if (window.innerWidth <= 767) {
      toggle.textContent = "VYBERTE ZVÝHODNĚNOU LIŠTU K PODLAZE";
    }
    toggle.classList.add("vp-toggle-btn");

    const content = document.createElement("div");
    content.style.display = "none";
    content.style.marginTop = "10px";

    toggle.addEventListener("click", () => {
      content.style.display =
        content.style.display === "none" ? "block" : "none";
    });

    box.append(toggle, content);

    listy.baseboards.forEach((b) => {
      const itemDiv = document.createElement("div");
      itemDiv.classList.add("vp-lisata-item");

      const type = b.type === "standard" ? "Basic" : "Premium";
      const img = b.image || b.shoptet?.variants?.[0]?.image || "";
      const price = b.shoptet?.variants?.[0]?.price
        ? b.shoptet.variants[0].price + " Kč"
        : "Cena neuvedena";

      itemDiv.innerHTML = `
        <img src="https://cdn.myshoptet.com/usr/727188.myshoptet.com/user/shop/orig/${img}" style="width:80px;height:80px;object-fit:contain;border:1px solid #ccc;border-radius:4px;">
        <div style="display:flex;align-items:center;gap:20px;width:100%;">
          <div><b>${type}:</b> ${b.name}</div>
          <div style="margin-left:auto;font-size:1.4rem;">${price} / ks</div>

          <button class="vp-add-lisata-btn btn btn-cart add-to-cart-button"
            data-parent-item-id="${parentItemId}"
            data-variant-code="${b.shoptet?.variants?.[0]?.code}"
            data-bm-per-piece="${b.bmPerPiece || 0}"
            data-guid="${guid}">
            Přidat lištu
          </button>
        </div>
      `;

      content.appendChild(itemDiv);
    });

    let insertTarget = row;
    let nextSibling = row.nextElementSibling;
    while (nextSibling && nextSibling.classList.contains("related")) {
      insertTarget = nextSibling;
      nextSibling = nextSibling.nextElementSibling;
    }
    insertTarget.after(box);
    row.classList.add("has-lisaty-box");
  });

  attachLisataButtons();
  attachQuantitySync();
}

function getItemId(row) {
  return row?.querySelector('input[name="itemId"]')?.value || null;
}

const _baseboardsCache = new Map();

function clearBaseboardsCache() {
  _baseboardsCache.clear();
}

async function fetchBaseboards(guid, pieces) {
  const key = `${guid}:${pieces}`;
  if (!_baseboardsCache.has(key)) {
    try {
      const res = await fetch(
        `https://vpodlahy.mirandamedia.io/api/eshop/product-with-baseboard/guid/${guid}?pieces=${pieces}`,
      );
      _baseboardsCache.set(key, res.ok ? await res.json() : null);
    } catch (e) {
      console.error("Chyba API:", e);
      _baseboardsCache.set(key, null);
    }
  }
  return _baseboardsCache.get(key);
}

async function calcTotalForSku(sku, links, overrides = {}) {
  let total = 0;
  for (const [parentId, skus] of Object.entries(links)) {
    if (!skus.includes(sku)) continue;
    let guid, pieces;
    if (overrides[parentId]) {
      ({ guid, pieces } = overrides[parentId]);
    } else {
      const row = document
        .querySelector(`input[name="itemId"][value="${parentId}"]`)
        ?.closest("tr");
      guid = row?.dataset.microIdentifier;
      pieces =
        parseInt(row?.querySelector('input[name="amount"]')?.value, 10) || 1;
    }
    if (!guid) continue;
    const data = await fetchBaseboards(guid, pieces);
    const b = data?.baseboards?.find(
      (b) => b.shoptet?.variants?.[0]?.code === sku,
    );
    if (b?.requiredPieces) total += b.requiredPieces;
  }
  return total;
}

function attachLisataButtons() {
  document.querySelectorAll(".vp-add-lisata-btn").forEach((btn) => {
    if (btn.dataset.listenerAttached) return;
    btn.dataset.listenerAttached = "true";

    btn.addEventListener("click", async () => {
      const variant = btn.dataset.variantCode;
      const parentItemId = btn.dataset.parentItemId;
      const bmPerPiece = parseFloat(btn.dataset.bmPerPiece) || 0;
      const guid = btn.dataset.guid;
      const unit = btn.dataset.unit || "ks";

      const parentRow = document
        .querySelector(`input[name="itemId"][value="${parentItemId}"]`)
        ?.closest("tr");
      const pieces =
        parseInt(parentRow?.querySelector('input[name="amount"]')?.value, 10) ||
        1;

      const links = JSON.parse(localStorage.getItem("lisatyLinks") || "{}");
      if (!links[parentItemId]) links[parentItemId] = [];
      if (!links[parentItemId].includes(variant))
        links[parentItemId].push(variant);

      clearBaseboardsCache();
      const totalAmount = await calcTotalForSku(variant, links, {
        [parentItemId]: { guid, pieces },
      });

      localStorage.setItem("lisatyLinks", JSON.stringify(links));

      const bmMap = JSON.parse(localStorage.getItem("lisatyBm") || "{}");
      bmMap[variant] = bmPerPiece;
      localStorage.setItem("lisatyBm", JSON.stringify(bmMap));

      const unitMap = JSON.parse(localStorage.getItem("lisatyUnit") || "{}");
      unitMap[variant] = unit;
      localStorage.setItem("lisatyUnit", JSON.stringify(unitMap));

      attachQuantitySync();

      try {
        await shoptet.cartShared.addToCart({
          productCode: variant,
          amount: totalAmount || pieces,
        });
        setTimeout(() => {
          updateLisatyCartUI();
        }, 100);
      } catch (e) {
        console.error("Chyba při přidávání lišty:", e);
      }
    });
  });
}

function attachQuantitySync() {
  const rows = document.querySelectorAll('tr[data-micro="cartItem"]');

  rows.forEach((row) => {
    const parentId = getItemId(row);
    if (!parentId) return;

    const input = row.querySelector('input[name="amount"]');
    if (!input) return;

    input.onchange = null;

    input.onchange = () => {
      const newQty = parseInt(input.value, 10) || 1;
      syncChildren(parentId, newQty);
    };

    const inc = row.querySelector("button.increase");
    const dec = row.querySelector("button.decrease");

    if (inc) {
      inc.onclick = () =>
        setTimeout(() => {
          syncChildren(parentId, parseInt(input.value, 10));
        }, 50);
    }

    if (dec) {
      dec.onclick = () =>
        setTimeout(() => {
          syncChildren(parentId, parseInt(input.value, 10));
        }, 50);
    }
  });
}

async function syncChildren(parentId, newQty) {
  const links = JSON.parse(localStorage.getItem("lisatyLinks") || "{}");
  const childSkus = links[parentId] || [];
  if (!childSkus.length) return;

  const parentRow = document
    .querySelector(`input[name="itemId"][value="${parentId}"]`)
    ?.closest("tr");
  const guid = parentRow?.dataset.microIdentifier;

  clearBaseboardsCache();

  for (const sku of childSkus) {
    const childRow = document.querySelector(
      `tr[data-micro="cartItem"][data-micro-sku="${sku}"]`,
    );
    if (!childRow) continue;

    const childItemId = childRow.querySelector('input[name="itemId"]').value;
    const priceId = childRow.querySelector('input[name="priceId"]').value;
    const childInput = childRow.querySelector('input[name="amount"]');
    if (!childInput) continue;

    const overrides = guid ? { [parentId]: { guid, pieces: newQty } } : {};
    const total = await calcTotalForSku(sku, links, overrides);
    const amount = total || newQty;

    // В syncChildren и cleanupLisatyLinks перед вызовом updateQuantityInCart:
    const currentVal = parseInt(childInput.value, 10);
    if (currentVal === amount) continue;

    childInput.value = amount;
    shoptet.cartShared.updateQuantityInCart({
      itemId: childItemId,
      priceId,
      amount,
    });
  }
}
let cleanupInProgress = false;

function cleanupLisatyLinks() {
  if (cleanupInProgress) return;

  const links = JSON.parse(localStorage.getItem("lisatyLinks") || "{}");

  const existingSkus = new Set(
    [...document.querySelectorAll('tr[data-micro="cartItem"]')]
      .map((row) => row.dataset.microSku)
      .filter(Boolean),
  );

  const skusBefore = new Set(Object.values(links).flat());

  let updated = false;

  Object.keys(links).forEach((parentId) => {
    const filtered = links[parentId].filter((sku) => existingSkus.has(sku));

    if (filtered.length !== links[parentId].length) {
      links[parentId] = filtered;
      updated = true;
    }

    if (links[parentId].length === 0) {
      delete links[parentId];
      updated = true;
    }
  });

  Object.keys(links).forEach((parentId) => {
    const parentRow = document
      .querySelector(`input[name="itemId"][value="${parentId}"]`)
      ?.closest("tr");
    if (!parentRow) {
      delete links[parentId];
      updated = true;
    }
  });

  if (updated) {
    localStorage.setItem("lisatyLinks", JSON.stringify(links));
  }

  const bmMap = JSON.parse(localStorage.getItem("lisatyBm") || "{}");
  Object.keys(bmMap).forEach((sku) => {
    if (!existingSkus.has(sku)) {
      delete bmMap[sku];
      updated = true;
    }
  });
  if (updated) localStorage.setItem("lisatyBm", JSON.stringify(bmMap));

  const updatedLinks = JSON.parse(localStorage.getItem("lisatyLinks") || "{}");
  const skusAfter = new Set(Object.values(updatedLinks).flat());

  const orphanedSkus = [...skusBefore].filter((sku) => !skusAfter.has(sku));
  for (const sku of orphanedSkus) {
    const childRow = document.querySelector(
      `tr[data-micro="cartItem"][data-micro-sku="${sku}"]`,
    );
    if (!childRow) continue;
    const childItemId = childRow.querySelector('input[name="itemId"]')?.value;
    if (childItemId) {
      shoptet.cartShared.removeFromCart({ itemId: childItemId });
    }
  }

  const allChildSkus = new Set(Object.values(updatedLinks).flat());
  if (allChildSkus.size === 0) return;

  cleanupInProgress = true;
  clearBaseboardsCache();

  const recalcPromises = [...allChildSkus].map(async (sku) => {
    const totalAmount = await calcTotalForSku(sku, updatedLinks);
    if (!totalAmount) return;

    const childRow = document.querySelector(
      `tr[data-micro="cartItem"][data-micro-sku="${sku}"]`,
    );
    if (!childRow) return;

    const childItemId = childRow.querySelector('input[name="itemId"]').value;
    const priceId = childRow.querySelector('input[name="priceId"]').value;
    const childInput = childRow.querySelector('input[name="amount"]');
    if (!childInput) return;

    const currentVal = parseInt(childInput.value, 10);
    if (currentVal === totalAmount) return;

    childInput.value = totalAmount;
    shoptet.cartShared.updateQuantityInCart({
      itemId: childItemId,
      priceId,
      amount: totalAmount,
    });
  });

  Promise.all(recalcPromises).then(() => {
    setTimeout(() => {
      cleanupInProgress = false;
    }, 1000);
  });
}

function updateLisatyCartUI() {
  const links = JSON.parse(localStorage.getItem("lisatyLinks") || "{}");
  const bmMap = JSON.parse(localStorage.getItem("lisatyBm") || "{}");
  const lisataSkus = new Set(Object.values(links).flat());

  document.querySelectorAll('tr[data-micro="cartItem"]').forEach((row) => {
    const sku = row.dataset.microSku;
    if (!lisataSkus.has(sku)) return;

    const input = row.querySelector('input[name="amount"]');
    if (input) {
      input.disabled = true;
      input.classList.add("vp-locked-amount");
    }

    const inc = row.querySelector("button.increase");
    const dec = row.querySelector("button.decrease");
    if (inc) inc.style.pointerEvents = "none";
    if (dec) dec.style.pointerEvents = "none";

    const bmPerPiece = bmMap[sku];
    if (!bmPerPiece) return;

    const amount = parseInt(input?.value, 10) || 1;
    const totalBm = (bmPerPiece * amount).toFixed(2);

    const nameEl = row.querySelector(".unit-value");
    if (!nameEl) return;

    let el = nameEl.querySelector(".product-sku-bm");
    if (!el) {
      el = document.createElement("div");
      el.classList.add("product-sku", "product-sku-bm");
      nameEl.appendChild(el);
    }
    el.innerHTML = `(${bmPerPiece} bm/ks, celkem ${totalBm} bm)`;
  });
}

function parentHasLisata(parentItemId) {
  const links = JSON.parse(localStorage.getItem("lisatyLinks") || "{}");
  return Array.isArray(links[parentItemId]) && links[parentItemId].length > 0;
}

function watchAddedToCartPopup() {
  const observer = new MutationObserver(() => {
    const popup = document.querySelector(".ao-product");
    if (!popup) return;

    if (popup.dataset.vpLocked) return;

    const links = JSON.parse(localStorage.getItem("lisatyLinks") || "{}");
    const lisataSkus = new Set(Object.values(links).flat());

    const skuEl = popup.querySelector("[data-variant-code]");
    const sku = skuEl?.dataset?.variantCode;

    if (!sku || !lisataSkus.has(sku)) return;

    popup.dataset.vpLocked = "true";

    const input = popup.querySelector('input[name="amount"]');
    if (input) {
      input.disabled = true;
    }

    const inc = popup.querySelector("button.increase");
    const dec = popup.querySelector("button.decrease");
    if (inc) inc.remove();
    if (dec) dec.remove();
  });

  observer.observe(document.body, { childList: true, subtree: true });
}

async function applyVzorkyDiscount() {
  if (_vzorkyInProgress) return;

  _vzorkyInProgress = true;

  try {
    const cartItems = dataLayer?.[0]?.shoptet?.cart || [];

    if (!cartItems.length) {
      await removeVzorkyCoupon();
      return;
    }

    const domPrices = {};
    document.querySelectorAll('tr[data-micro="cartItem"]').forEach((row) => {
      const sku = row.dataset.microSku;
      const priceEl = row.querySelector('[data-testid="cartItemPrice"]');
      if (sku && priceEl) {
        const text = priceEl.textContent
          .trim()
          .replace(",", ".")
          .replace(/[^\d.]/g, "");
        domPrices[sku] = parseFloat(text) || 0;
      }
    });

    const payload = cartItems.map((i) => ({
      code: i.code,
      price: domPrices[i.code] || parseFloat(i.priceWithVat) || 0,
      amount: parseInt(i.quantity, 10) || 1,
    }));

    const res = await fetch(SAMPLE_API, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ cartItems: payload }),
    });

    if (!res.ok) {
      console.error("Vzorky API error:", res.status);
      return;
    }

    const data = await res.json();
    console.log("Vzorky discount response:", data);

    // Žádné vzorky v košíku — odstraníme kupón
    if (data.sampleCount === 0 || !data.couponCode) {
      await removeVzorkyCoupon();
      return;
    }

    // Stejná výše slevy a kupón je už aplikován — nic nedělat
    const roundedAmount = parseFloat(data.discountAmount.toFixed(5));
    if (roundedAmount === _lastDiscountAmount && _lastAppliedCoupon) return;

    if (_lastAppliedCoupon) {
      // Jiná výše slevy — nejdřív odebereme starý kupón, pak aplikujeme nový
      _pendingCoupon = `${data.couponCode}|${roundedAmount}`;
      sessionStorage.setItem("vzorkyPendingCoupon", _pendingCoupon);
      await removeVzorkyCoupon();
      // Po odebrání Shoptet znovu načte košík (AJAX nebo reload)
      // _pendingCoupon bude aplikován v ShoptetDOMCartContentLoaded nebo při page loadu
    } else {
      await applyCoupon(data.couponCode, roundedAmount);
    }
  } catch (err) {
    console.error("Vzorky chyba:", err);
  } finally {
    _vzorkyInProgress = false;
  }
}

// ─── Aplikace kupónu ──────────────────────────────────────────
async function applyCoupon(code, discountAmount) {
  const couponInput = document.querySelector(
    'input[name="discountCouponCode"]',
  );
  const couponForm = document.querySelector(
    'form[action="/action/Cart/addDiscountCoupon/"]',
  );

  if (!couponInput || !couponForm) {
    console.warn("Vzorky: formulář kupónu nenalezen");
    return;
  }

  // Pokud je v košíku jiný kupón (zadaný ručně), nepřepisovat
  const appliedInternalCode = document.querySelector(
    '.discount-coupon .applied-coupon input[name="internalCode"]',
  )?.value;
  if (
    appliedInternalCode &&
    appliedInternalCode !== code &&
    appliedInternalCode !== _lastAppliedCoupon
  ) {
    console.log(
      "Vzorky: košík má jiný kupón, přeskakuji:",
      appliedInternalCode,
    );
    return;
  }

  couponInput.value = code;
  _lastAppliedCoupon = code;
  sessionStorage.setItem("vzorkyCoupon", code);
  if (discountAmount !== undefined) {
    _lastDiscountAmount = discountAmount;
    sessionStorage.setItem("vzorkyDiscountAmount", discountAmount);
  }

  const submitBtn = couponForm.querySelector(
    '[data-testid="buttonSubmitDiscountCoupon"]',
  );
  if (submitBtn) {
    submitBtn.click();
  } else {
    couponForm.submit();
  }
}

// ─── Odstranění kupónu ────────────────────────────────────────
async function removeVzorkyCoupon() {
  const removeBtn = document.querySelector(
    '[data-testid="buttonRemoveDiscountCoupon"]',
  );
  const appliedCouponEl = document.querySelector(
    ".discount-coupon .applied-coupon",
  );

  if (!removeBtn && !_lastAppliedCoupon) return;

  // Pokud je v košíku jiný kupón (zadaný ručně), neodstraňovat
  if (appliedCouponEl) {
    const internalCode = appliedCouponEl.querySelector(
      'input[name="internalCode"]',
    )?.value;
    if (
      internalCode &&
      _lastAppliedCoupon &&
      internalCode !== _lastAppliedCoupon
    ) {
      console.log("Vzorky: jiný kupón v košíku, nepřepisuji:", internalCode);
      _lastAppliedCoupon = null;
      sessionStorage.removeItem("vzorkyCoupon");
      return;
    }
  }

  try {
    if (removeBtn) {
      removeBtn.click();
    }
    console.log("Vzorky: kupón odstraněn");
  } catch (err) {
    console.error("Vzorky: chyba při odstraňování kupónu:", err);
  } finally {
    _lastAppliedCoupon = null;
    _lastDiscountAmount = 0;
    sessionStorage.removeItem("vzorkyCoupon");
    sessionStorage.removeItem("vzorkyDiscountAmount");
  }
}
